const categoryPaths = {
    Eventy: "/eventy",
    Muzea: "/kultura/muzea",
    Teatry: "/kultura/teatry",
    Kina: "/kultura/kina",
    Zabytki: "/kultura/zabytki",
    KulturaInne: "/kultura/kulturaInne",
    Restauracje: "/gastronomia/restauracje",
    "Fast Foody": "/gastronomia/fastFoody",
    Kawiarnie: "/gastronomia/kawiarnie",
    Desery: "/gastronomia/desery",
    GastronomiaInne: "/gastronomia/gastronomiaInne",
    Biblioteki: "/nauka/biblioteki",
    Księgarnie: "/nauka/ksiegarnie",
    Kursy: "/nauka/kursy",
    "Targi i kiermasze": "/nauka/targi",
    NaukaInne: "/nauka/naukaInne",
};

export function getCategoryPath(category) {
    return categoryPaths[category] ?? "/";
}